import {
  faMagnifyingGlassMinus,
  faMagnifyingGlassPlus,
  faTimes,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect } from 'react';
import { TransformComponent, TransformWrapper, useControls } from 'react-zoom-pan-pinch';

import { ImgInfo } from '@/modules/blog/article_components/MainContent';

const Controls = ({ resetImgURL }: { resetImgURL: () => void }) => {
  const { zoomIn, zoomOut } = useControls();
  return (
    <div className='tools tools-full-screen-img inline-flex w-fit flex-row gap-2 rounded-xl bg-black p-2'>
      <FontAwesomeIcon
        className='cursor-pointer text-white hover:opacity-70'
        size='lg'
        icon={faMagnifyingGlassPlus}
        onClick={() => zoomIn()}
      />
      <FontAwesomeIcon
        className='cursor-pointer text-white hover:opacity-70'
        size='lg'
        icon={faMagnifyingGlassMinus}
        onClick={() => zoomOut()}
      />
      <FontAwesomeIcon
        className='cursor-pointer text-white hover:opacity-70'
        size='lg'
        icon={faTimes}
        onClick={() => resetImgURL()}
      />
    </div>
  );
};

export interface ImagePreviewAndZoomProps {
  imgInfo: ImgInfo;
  resetImgURL: () => void;
}

const ImagePreviewAndZoom = ({ imgInfo, resetImgURL }: ImagePreviewAndZoomProps) => {
  // Function to handle click events on the document
  const handleClick = (event: MouseEvent) => {
    // Check if the clicked element or any of its children has the class "full-screen-img" or "tools-full-screen-img"
    const clickedElement = event.target as HTMLElement;

    const classesArray = [...clickedElement.classList];

    const hasClass =
      classesArray.includes('react-transform-wrapper') ||
      classesArray.includes('react-transform-component') ||
      classesArray.includes('full-screen-img') ||
      classesArray.includes('tools-full-screen-img') ||
      classesArray.includes('fa-magnifying-glass-plus') ||
      classesArray.includes('fa-magnifying-glass-minus') ||
      clickedElement.tagName.toLowerCase() === 'path';

    if (!hasClass) {
      resetImgURL(); // Call the resetImgURL function if no element with the class "full-screen-img" or "tools-full-screen-img" is found
    }
  };

  // Attach click event listener to the document
  useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []); // Empty dependency array to ensure the effect runs only once

  return (
    <TransformWrapper initialScale={1} centerOnInit>
      <TransformComponent contentClass='!h-[94%]'>
        <img
          src={imgInfo.src}
          alt={imgInfo.alt}
          className='full-screen-img max-h-full w-auto max-w-full'
        />
      </TransformComponent>
      <Controls resetImgURL={resetImgURL} />
    </TransformWrapper>
  );
};

export default ImagePreviewAndZoom;
